export const HIT_DASHBOARD = 'HIT_DASHBOARD';
export const GET_DASHBOARD = 'GET_DASHBOARD';

export const HIT_DASHBOARD_COUNT = 'HIT_DASHBOARD_COUNT';
export const GET_DASHBOARD_COUNT = 'GET_DASHBOARD_COUNT';

